import axios from "axios";
import { toast } from "react-toastify";
import { GET_LANDING_PAGE_INFO, LANDING_PAGE_INFO_ERROR } from "../types";

export const getLandingPageData = (e) => async (dispatch) => {
  try {
    var data = new FormData();

    var config = {
      method: "get",
      headers: {},
      url: `${process.env.NEXT_PUBLIC_API_URL}/landing-page`,
      data: data,
    };
    const res = await axios(config);
    if (res.data.success) {
      dispatch({
        type: GET_LANDING_PAGE_INFO,
        payload: res.data,
      });
    }
  } catch (error) {
    toast.error(error.response, {
      onClose: () => location.reload(),
    });
    dispatch({
      type: LANDING_PAGE_INFO_ERROR,
      payload: error.response,
    });
  }
};
